import { useFullScreenContext } from 'context/FullScreen';
import React from 'react';
import Portal from './Portal';

function FullScreenPortal({ container, children }) {
    const { fullScreen } = useFullScreenContext();
    container = fullScreen ? 'fullscreen-portal' : container;
    return (
        <>
            {container ? (
                <Portal container={container}> {children}</Portal>
            ) : (
                children
            )}
        </>
    );
}

export default FullScreenPortal;
